import React from 'react';
import { motion } from 'framer-motion';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white pt-24 sm:pt-28 pb-16 sm:pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-6 text-text-primary">Terms of Service</h1>
          <p className="text-text-secondary mb-8">Last updated: January 2026</p>
          <div className="space-y-8 text-text-secondary">
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">By accessing or using Jelly Local's services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">2. Description of Services</h2>
              <p className="leading-relaxed">Jelly Local provides full-service local marketing solutions, including but not limited to Google Ads management, local SEO, lead generation, reputation management, and digital marketing services ("Services").</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">3. User Responsibilities</h2>
              <p className="leading-relaxed mb-4">You agree to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide accurate, current, and complete information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
                <li>Use our Services in compliance with all applicable laws and regulations</li>
                <li>Not use our Services for any illegal or unauthorized purpose</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">4. Payment Terms</h2>
              <p className="leading-relaxed mb-4">By using our paid Services, you agree to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Pay all fees associated with your selected service package</li>
                <li>Provide valid payment information</li>
                <li>Authorize us to charge your payment method on a recurring basis (if applicable)</li>
                <li>Pay any applicable taxes</li>
              </ul>
              <p className="leading-relaxed mt-4">Setup fees, where applicable, are one-time charges and non-refundable.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">5. Cancellation and Refunds</h2>
              <p className="leading-relaxed">You may cancel your service at any time with no long-term contract obligations. Cancellations must be submitted in writing. Refunds are provided at our discretion and are subject to our refund policy. Setup fees and completed work are non-refundable.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">6. Service Performance</h2>
              <p className="leading-relaxed">While we strive to deliver excellent results, we cannot guarantee specific outcomes such as search rankings, lead volume, or revenue increases. Results may vary based on factors including industry, competition, budget, and market conditions.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">7. Intellectual Property</h2>
              <p className="leading-relaxed">All content, materials, and intellectual property provided by Jelly Local remain our property. You are granted a limited, non-exclusive license to use our Services. Upon completion of services and full payment, you own the content created specifically for your business (such as website content, ad copy, etc.).</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">8. Limitation of Liability</h2>
              <p className="leading-relaxed">To the maximum extent permitted by law, Jelly Local shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including lost profits, lost revenue, or lost data, arising from your use of our Services.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">9. Indemnification</h2>
              <p className="leading-relaxed">You agree to indemnify and hold Jelly Local harmless from any claims, damages, losses, liabilities, and expenses (including legal fees) arising from your use of our Services or violation of these Terms.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">10. Modifications to Terms</h2>
              <p className="leading-relaxed">We reserve the right to modify these Terms at any time. We will notify you of any material changes by posting the new Terms on our website. Your continued use of our Services after such modifications constitutes acceptance of the updated Terms.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">11. Termination</h2>
              <p className="leading-relaxed">We reserve the right to suspend or terminate your access to our Services at any time, with or without cause, with or without notice, for any reason including violation of these Terms.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">12. Governing Law</h2>
              <p className="leading-relaxed">These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">13. Contact Information</h2>
              <p className="leading-relaxed">If you have any questions about these Terms of Service, please contact us at:</p>
              <div className="mt-4 space-y-2">
                <p>Email: support@jellylocal.com</p>
                <p>Phone: 251-243-1403</p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">14. Entire Agreement</h2>
              <p className="leading-relaxed">These Terms constitute the entire agreement between you and Jelly Local regarding the use of our Services and supersede any prior agreements.</p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsPage;